import React, { useState, useEffect } from "react";
import {
  Avatar,
  Box,
  Button,
  Grid2,
  MenuItem,
  InputLabel,
  FormControl,
  Select,
  FormHelperText,
} from "@mui/material";
import Header from "../Header/Header";
import TextField from "@mui/material/TextField";
import consts from "../../constant";
import Axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import toast, { Toaster } from "react-hot-toast";
import { useForm, Controller } from "react-hook-form";
import "./TradePair.css";
import { ToastContainer } from "react-toastify";

const drawerWidth = 260;

const CreateTradepair = () => {
  const token = localStorage.getItem("adminToken");
  const theme = useTheme();
  const lg = useMediaQuery(theme.breakpoints.up("lg"));
  const detail = useLocation();
  const [reason, setReason] = useState();
  const [reasons, setReasons] = useState(false);
  const Navigate = useNavigate();
  const back = useNavigate();

  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    console.log(data, "gvghcsv");
    try {
      console.log(data, "gvghcsv");

      const response = await Axios.post(
        `${consts.BackendUrl}/admin/addtradepair`,

        data,
        {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers": "Content-Type, Authorization",
            "Access-Control-Allow-Credentials": "true",
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
            // Authorization: token,
          },
        }
      );

      const { data: responseData } = response;

      if (responseData?.success) {
        toast.success(responseData?.message || "Operation successful!");
        setTimeout(() => {
          back(`/${consts.route}/tradepair`);
        }, 1000);
      } else {
        toast.error(responseData?.message || "An unexpected error occurred.");
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong!";
      toast.error(errorMessage);
      console.error(error, "Error creating pair");
    }
  };

  const [selectedType, setSelectedType] = useState("");

  const handleChange = (event) => {
    setSelectedType(event.target.value);
  };

  // Handle manual state update (example of using setValue)
  const handleStateChange = (event) => {
    const newType = event.target.value;
    setSelectedType(newType);
    setValue("type", newType);
  };

  const handleImageUpload = async (event, form) => {
    const file = event.target.files[0];
    if (file) {
      try {
        const formData = new FormData();
        formData.append("image", file);

        const response = await Axios.post(
          `${consts.BackendUrl}/admin/imageUploadAdmin`,
          formData,
          {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Headers": "Content-Type, Authorization",
              "Access-Control-Allow-Credentials": "true",
              "Access-Control-Allow-Methods":
                "GET,PUT,POST,DELETE,PATCH,OPTIONS",
              Authorization: token,
            },
          }
        );
        console.log(response, "response");
        if (response?.data?.success) {
          if (form) {
            setValue("icon", response?.data?.result);
            setValue("image", response?.data?.result);
          } else {
            const uploadedImageUrl = response?.data?.result;
          }
        } else {
          console.error("Failed to upload image. No URL returned.");
        }
      } catch (error) {
        console.error("Error uploading image:", error);
      }
    }
  };

  return (
    <div className="UserList create-asset">
      <ToastContainer />
      <Box sx={{ display: lg ? "flex" : "block" }}>
        <Header />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 5,
            width: { lg: `calc(100% - ${drawerWidth}px)` },
            marginTop: "50px",
          }}
        >
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid2 container spacing={2}>
              <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                <div className="d-flex align-fe">
                  <Button
                    className="Backbutton"
                    variant="contained"
                    onClick={() => {
                      back(`/${consts.route}/tradepair`);
                    }}
                  >
                    Back
                  </Button>
                </div>

                <div
                  className="image-upload-section mt-20"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "20px",
                  }}
                >
                  <Controller
                    name="image"
                    control={control}
                    rules={{ required: "Image is required" }}
                    render={({ field }) => (
                      <>
                        <Avatar
                          alt="Current Image"
                          src={field?.value ? field?.value : undefined}
                          sx={{ width: 80, height: 80, marginRight: "20px" }}
                        />
                        <Button variant="contained" component="label">
                          Upload Image
                          <input
                            type="file"
                            hidden
                            accept="image/*"
                            onChange={(e) => {
                              handleImageUpload(e, "form");
                              field.onChange(e.target.files[0]);
                            }}
                          />
                        </Button>
                      </>
                    )}
                  />
                </div>
                {errors.image && <p className="err">{errors.image.message}</p>}

                <div className="custom_table p-10">
                  <Grid2
                    container
                    spacing={0}
                    style={{ height: "100%" }}
                    alignItems={"center"}
                  >
                    <Grid2
                      item
                      size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}
                      sx={{
                        "& .MuiInputBase-input.MuiOutlinedInput-input": {
                          color: "white",
                        },
                      }}
                    >
                      <div className="view-inp p-10">
                        <div className=" txt-white ">Price</div>
                        <div className="mt-10">
                          <TextField
                            {...register("price", {
                              required: "Price is required",
                            })}
                            id="outlined-basic"
                            variant="outlined"
                            type="number"
                            fullWidth
                          />
                          <p className="err">{errors?.price?.message}</p>
                        </div>
                      </div>

                      <div className="view-inp p-10">
                        <div className=" txt-white ">Min buy price</div>
                        <div className="mt-10">
                          <TextField
                            {...register("min_buy_price", {
                              required: "Min buy price required",
                            })}
                            id="outlined-basic"
                            variant="outlined"
                            type="number"
                            fullWidth
                          />
                        </div>
                        <p className="err">{errors?.min_buy_price?.message}</p>
                      </div>

                      <div className="view-inp p-10">
                        <div className=" txt-white ">Min sell price</div>
                        <div className="mt-10">
                          <TextField
                            {...register("min_sell_price", {
                              required: "Min sell price required",
                            })}
                            id="outlined-basic"
                            variant="outlined"
                            type="number"
                            fullWidth
                          />
                        </div>
                        <p className="err">{errors?.min_sell_price?.message}</p>
                      </div>

                      <div className="view-inp p-10">
                        <div className=" txt-white ">Min buy quantity</div>
                        <div className="mt-10">
                          <TextField
                            {...register("min_buy_quantity", {
                              required: "Min buy quantity required",
                            })}
                            id="outlined-basic"
                            variant="outlined"
                            type="number"
                            fullWidth
                          />
                        </div>
                        <p className="err">
                          {errors?.min_buy_quantity?.message}
                        </p>
                      </div>
                      <div className="view-inp p-10">
                        <div className=" txt-white ">Min sell quantity</div>
                        <div className="mt-10">
                          <TextField
                            {...register("min_sell_quantity", {
                              required: "Min sell quantity required",
                            })}
                            id="outlined-basic"
                            variant="outlined"
                            type="number"
                            fullWidth
                          />
                        </div>
                        <p className="err">
                          {errors?.min_sell_quantity?.message}
                        </p>
                      </div>
                      <div className="view-inp p-10">
                        <div className=" txt-white ">Buy trade commission</div>
                        <div className="mt-10">
                          <TextField
                            {...register("buy_trade_commission", {
                              required: "Buy trade commission required",
                            })}
                            id="outlined-basic"
                            variant="outlined"
                            type="number"
                            fullWidth
                            min="0.000001"
                          />
                        </div>
                        <p className="err">
                          {errors?.buy_trade_commission?.message}
                        </p>
                      </div>
                      <div className="view-inp p-10">
                        <div className=" txt-white ">Base asset name</div>
                        <div className="mt-10">
                          <TextField
                            {...register("base_asset_name", {
                              required: "Base asset name required",
                            })}
                            id="outlined-basic"
                            variant="outlined"
                            fullWidth
                          />
                        </div>
                        <p className="err">
                          {errors?.base_asset_name?.message}
                        </p>
                      </div>

                      <div className="view-inp p-10">
                        <div className="txt-white">
                          Buy trade commission type
                        </div>
                        <div className="mt-10">
                          <FormControl
                            fullWidth
                            variant="outlined"
                            error={!!errors.Buy_trade_commission_type}
                          >
                            <Controller
                              name="buy_trade_commission_type"
                              control={control}
                              defaultValue=""
                              rules={{
                                required: "Commission Type is required", // Validation rule
                              }}
                              render={({ field }) => (
                                <Select
                                  labelId="commission-type-label"
                                  id="commission-type-select"
                                  label="Commission Type"
                                  {...field}
                                  sx={{
                                    "& .MuiSelect-icon": { color: "white" },
                                    "& .MuiSelect-select": { color: "white" },
                                  }}
                                >
                                  <MenuItem value="percentage">
                                    Percentage
                                  </MenuItem>
                                  <MenuItem value="fixed">Fixed</MenuItem>
                                </Select>
                              )}
                            />
                          </FormControl>
                          {errors.buy_trade_commission_type && (
                            <p className="err">
                              {errors?.Buy_trade_commission_type?.message}
                            </p>
                          )}
                        </div>
                      </div>
                    </Grid2>
                    <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}>
                      <div className="view-inp p-10">
                        <div className="txt-white">Type</div>
                        <div className="mt-10">
                          <FormControl
                            fullWidth
                            variant="outlined"
                            error={!!errors.type}
                          >
                            <Controller
                              name="type" // The name of the field in the form data
                              control={control} // Provide control to the Controller component
                              defaultValue={selectedType} // Set default value
                              rules={{
                                required: "Type is required", // Field is required
                              }}
                              render={({ field }) => (
                                <Select
                                  labelId="type-label"
                                  id="type-select"
                                  label="Type"
                                  {...field} // Spread the field props here to bind to the Select component
                                  value={selectedType} // Set the value to the selectedType state
                                  onChange={(e) => {
                                    handleStateChange(e); // Update both form and local state
                                    field.onChange(e); // Update form state using react-hook-form
                                  }}
                                  sx={{
                                    "& .MuiSelect-icon": {
                                      color: "white", // Dropdown icon color
                                    },
                                    "& .MuiSelect-select": {
                                      color: "white", // Text color for selected value
                                    },
                                  }}
                                >
                                  <MenuItem value={"spot"}>SPOT</MenuItem>
                                  <MenuItem value={"margin"}>MARGIN</MenuItem>
                                  <MenuItem value={"future"}>FUTURE</MenuItem>
                                </Select>
                              )}
                            />
                          </FormControl>
                          {errors.type && (
                            <p className="err">{errors?.type?.message}</p>
                          )}
                        </div>
                      </div>

                      <div className="view-inp p-10">
                        <div className=" txt-white ">Max buy price</div>
                        <div className="mt-10">
                          <TextField
                            sx={{
                              "& .MuiInputBase-input.MuiOutlinedInput-input": {
                                color: "white",
                              },
                            }}
                            {...register("max_buy_price", {
                              required: "Max buy price required",
                            })}
                            id="outlined-basic"
                            variant="outlined"
                            type="number"
                            fullWidth
                          />
                        </div>
                        <p className="err">{errors?.max_buy_price?.message}</p>
                      </div>

                      <div className="view-inp p-10">
                        <div className=" txt-white ">Max sell price</div>
                        <div className="mt-10">
                          <TextField
                            sx={{
                              "& .MuiInputBase-input.MuiOutlinedInput-input": {
                                color: "white",
                              },
                            }}
                            {...register("max_sell_price", {
                              required: "Max sell price required",
                            })}
                            id="outlined-basic"
                            variant="outlined"
                            type="number"
                            fullWidth
                          />
                        </div>
                        <p className="err">{errors?.max_sell_price?.message}</p>
                      </div>

                      <div className="view-inp p-10">
                        <div className=" txt-white ">Max buy quantity</div>
                        <div className="mt-10">
                          <TextField
                            sx={{
                              "& .MuiInputBase-input.MuiOutlinedInput-input": {
                                color: "white",
                              },
                            }}
                            {...register("max_buy_quantity", {
                              required: "Max buy quantity required",
                            })}
                            id="outlined-basic"
                            variant="outlined"
                            type="number"
                            fullWidth
                          />
                        </div>
                        <p className="err">
                          {errors?.max_buy_quantity?.message}
                        </p>
                      </div>
                      <div className="view-inp p-10">
                        <div className=" txt-white ">Max sell quantity</div>
                        <div className="mt-10">
                          <TextField
                            sx={{
                              "& .MuiInputBase-input.MuiOutlinedInput-input": {
                                color: "white",
                              },
                            }}
                            {...register("max_sell_quantity", {
                              required: "Max sell quantity required",
                            })}
                            id="outlined-basic"
                            variant="outlined"
                            type="number"
                            fullWidth
                          />
                        </div>
                        <p className="err">
                          {errors?.max_sell_quantity?.message}
                        </p>
                      </div>
                      <div className="view-inp p-10">
                        <div className=" txt-white ">Sell trade commission</div>
                        <div className="mt-10">
                          <TextField
                            sx={{
                              "& .MuiInputBase-input.MuiOutlinedInput-input": {
                                color: "white",
                              },
                            }}
                            {...register("sell_trade_commission", {
                              required: "Sell trade commission required",
                            })}
                            id="outlined-basic"
                            variant="outlined"
                            type="number"
                            fullWidth
                            min="0.000001"
                          />
                        </div>
                        <p className="err">
                          {errors?.sell_trade_commission?.message}
                        </p>
                      </div>
                      <div className="view-inp p-10">
                        <div className=" txt-white ">Market asset name</div>
                        <div className="mt-10">
                          <TextField
                            sx={{
                              "& .MuiInputBase-input.MuiOutlinedInput-input": {
                                color: "white",
                              },
                            }}
                            {...register("market_asset_name", {
                              required: "Market asset name required",
                            })}
                            id="outlined-basic"
                            variant="outlined"
                            fullWidth
                          />
                        </div>
                        <p className="err">
                          {errors?.market_asset_name?.message}
                        </p>
                      </div>

                      <div className="view-inp p-10">
                        <div className="txt-white">
                          Sell trade commission type
                        </div>
                        <div className="mt-10">
                          <FormControl
                            sx={{
                              "& .MuiInputBase-input.MuiOutlinedInput-input": {
                                color: "white",
                              },
                            }}
                            fullWidth
                            variant="outlined"
                            error={!!errors.sell_trade_commission_type}
                          >
                            <Controller
                              name="sell_trade_commission_type"
                              control={control}
                              defaultValue=""
                              rules={{
                                required: "Commission Type is required",
                              }}
                              render={({ field }) => (
                                <Select
                                  labelId="commission-type-label"
                                  id="commission-type-select"
                                  label="Commission Type"
                                  {...field}
                                  sx={{
                                    "& .MuiSelect-icon": { color: "white" },
                                    "& .MuiSelect-select": { color: "white" },
                                  }}
                                >
                                  <MenuItem value="percentage">
                                    Percentage
                                  </MenuItem>
                                  <MenuItem value="fixed">Fixed</MenuItem>
                                </Select>
                              )}
                            />
                          </FormControl>
                          {errors.sell_trade_commission_type && (
                            <p className="err">
                              {errors?.sell_trade_commission_type?.message}
                            </p>
                          )}
                        </div>
                      </div>
                    </Grid2>
                  </Grid2>

                  <Button
                    type="submit"
                    variant="contained"
                    sx={{ margin: "20px 10px", padding: "8px 40px" }}
                  >
                    Save
                  </Button>
                </div>
              </Grid2>
            </Grid2>
          </form>
        </Box>
      </Box>
      <Toaster />
    </div>
  );
};

export default CreateTradepair;
